import { $, freeze, handleESC } from '../utils/Utils'

const mobileNav = (() => {
  const config = {
    get triggers() {
      return this.triggerCN
        .map(CN => [...document.querySelectorAll(`.${CN}`)])
        .reduce((acc, current) => [...acc, ...current])
    },
    triggerCN: ['nav__mobile'],
    checkbox: ['nav__trigger--main'],
    mobileNav: ['nav__mobile'],
    bodyCN: 'mobilenav-open',
  }

  const hideNav = () => {
    $(`.${config.checkbox}`)[0].checked = false
    document.body.classList.remove(config.bodyCN)
    freeze.stop()
    handleESC.stop()
  }

  const showNav = () => {
    document.body.classList.add(config.bodyCN)
    handleESC.init(() => hideNav())
    freeze.start()
  }

  const handleClick = ({ e }) => {
    if (
      document.body.classList.contains(config.bodyCN) &&
      !$(`.${config.mobileNav}`)[0].contains(e.target)
    ) {
      hideNav()
    }
  }

  const handleChange = () => {
    if ($(`.${config.checkbox}`)[0].checked) {
      showNav()
    } else {
      hideNav()
    }
  }

  const init = () => {
    if (config.triggers.length > 0) {
      // Close mobile nav if click on outside area
      document.addEventListener('click', e => handleClick({ e }))

      // Add body class if nav is open
      const checkbox = $(`.${config.checkbox}`)[0]
      checkbox.addEventListener('change', () => handleChange())

      let event
      if (typeof Event === 'function') {
        event = new Event('change')
      } else {
        event = document.createEvent('Event')
        event.initEvent('change', true, true)
      }

      checkbox.dispatchEvent(event)
    }
  }

  return {
    init,
  }
})()

export const queueMenu = () =>
  setTimeout(() => {
    mobileNav.init()
  }, 1000)

mobileNav.init()
